<template>
  <AppHeader>Delivery Person Transaction</AppHeader>

  <Loading v-if="state === 'loading'" />

  <div v-if="state === 'idle'" class="p-4">
    <div class="p-3 bg-white shadow-md rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-lg text-gray-600">Month</p>
        <select class="w-full mt-2 bg-transparent outline-none" v-model="form.month">
          <option value="">-- Select Month --</option>
          <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-400" v-if="errors.month">{{ errors.month }}</p>
      </div>
    </div>

    <div class="mt-4 responsive-table" v-if="transactions.length">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Purpose</th>
            <th>Payable Days</th>
            <th>Earning Basic</th>
            <th>Allowance</th>
            <th>Other</th>
            <th>Deduction (Vehicle)</th>
            <th>Deduction (Late Login)</th>
            <th>Deduction (Advance)</th>
            <th>Deduction (Other)</th>
            <th>Payable</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="t in transactions" :key="t.id">
            <td>{{ t.id }}</td>
            <td class="lowercase first-letter:uppercase">{{ t.delivery_person.name }}</td>
            <td>{{ t.purpose }}</td>
            <td>{{ t.payable_days }}</td>
            <td>{{ t.earning_basic }}</td>
            <td>{{ t.earning_allowance }}</td>
            <td>{{ t.earning_other }}</td>
            <td>{{ t.deduction_vehicle }}</td>
            <td>{{ t.deduction_late_login }}</td>
            <td>{{ t.deduction_advance }}</td>
            <td>{{ t.deduction_other }}</td>
            <td>{{ toInr(t.earning_basic + t.earning_allowance + t.earning_other - t.deduction_vehicle - t.deduction_late_login - t.deduction_advance - t.deduction_other) }}</td>
            <td>{{ t.status }}</td>
          </tr>
        </tbody>
      </table>

      <div class="m-3">
        <button @click="openTransactionsDownloadUrl" class="px-2 py-1 mr-1 text-white rounded-full bg-slate-500">Download Excel</button>
      </div>
    </div>

    <p v-else class="mt-4 text-gray-500 text-center">No records found.</p>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue'
import Loading from '@/components/common/Loading.vue'
import mixin from '@/utils/mixin.js'
import formMixin from '@/utils/mixins/form'

export default {
  name: 'ReportDeliveryPersonsTransactionSummary',
  mixins: [mixin, formMixin],
  components: { AppHeader, Loading },

  data() {
    return {
      state: 'loading',
      months: [],
      form: {
        month: '',
      },
      transactions: [],
    }
  },

  watch: {
    'form.month'(val) {
      if (val) {
        this.filterAttendance()
      } else {
        this.transactions = []
      }
    },
  },

  methods: {
    getData() {
      this.state = 'loading'
      this.request('GET', 'reports/delivery-persons/transaction-summary', null, (resp) => {
        this.state = 'idle'
        if (resp.success) {
          this.months = resp.data.months || []
        }
      })
    },

    filterAttendance() {
      this.state = 'loading'
      this.transactions = []
      this.request('GET', 'reports/delivery-persons/transaction-summary?month=' + this.form.month, null, (resp) => {
          this.state = 'idle'
          if (resp.success) {
            this.transactions = resp.data.transactions || []
          } else {
            this.transactions = []
          }
        }
      )
    },

    openTransactionsDownloadUrl() {
      this.openDownloadUrl('utils/reports/delivery-persons-transaction/' + btoa(this.$store.state.user.id + ':' + this.form.month) + '/download')
    },
  },

  created() {
    this.getData()
  },
}
</script>
